module.exports = __webpack_public_path__ + "static/media/avatar3.d5f40349.jpg";